import tw from "twin.macro"
import { ContentSlider } from "../../organisms/Homepage/ContentSlider"
import React, { useEffect, useState } from "react"
import { VideoBlocksProps } from "./VideoBlocks.d"
import useTealiumEvent from "../../../hooks/Tealium/useTealiumEvent"

const VideoBlocks: React.FC<VideoBlocksProps> = ({
  videoBlockHeader,
  videoBlockHeading,
  sectionTitle,
  sectionSlug,
  videoBlock,
}) => {
  const { trackTealEvent } = useTealiumEvent()

  return (
    <>
      {videoBlockHeader && (
        <h2
          css={[
            tw`text-2xl text-center font-light max-w-3xl mx-auto mb-6`,
            tw`lg:(text-4xl pt-20)`,
            "letter-spacing: 7.72px",
          ]}
        >
          {videoBlockHeader}
        </h2>
      )}
      {videoBlockHeading && (
        <p
          css={[
            tw`text-base mx-8 mb-20 font-book md:(max-w-5xl mx-auto mb-8 text-center)`,
          ]}
        >
          {videoBlockHeading}
        </p>
      )}
      <section css={[tw`w-full h-[32rem] bg-black z-40`]}>
        <ContentSlider
          sectionTitle={sectionTitle}
          analyticsId="video:video"
          sectionSlug={sectionSlug}
          css={[tw`h-[32rem] overflow-y-hidden`]}
          arrowStyles={{
            left: tw`top-[50%] left-2 xl:(left-8) hover:(bg-white bg-opacity-75) focus:(bg-white bg-opacity-75) `,
            right: tw`top-[50%] right-2 xl:(right-8)  hover:(bg-white bg-opacity-75) focus:(bg-white bg-opacity-75)`,
            color: "red-400",
          }}
        >
          {videoBlock?.map(({ heading, video_s3 }, i: number) => {
            const [active, setActive] = useState(false)
            const isBrowser = typeof window !== "undefined"
            const videoDiv =
              isBrowser && document?.getElementById(`${heading}-${i}`)
            const [mobileView, setMobileView] = useState(null)

            useEffect(() => {
              const mediaQuery = window.matchMedia("(max-width: 1024px)")
              setMobileView(mediaQuery.matches || false)
              mediaQuery.addEventListener("change", e => {
                const mobileViewOn = e.matches
                setMobileView(mobileViewOn)
              })
            }, [])

            // tealium
            const tealVideoEvent = (action: string, time?: string) => {
              const percentWatched = () => {
                var seconds = videoDiv?.duration % 60
                const percentage = Math.round(
                  (videoDiv?.currentTime / seconds) * 100,
                )
                // (Put the minutes and seconds in the display)

                return percentage
              }

              const timeOnPause = `${percentWatched()}:${Math.round(
                videoDiv?.currentTime,
              )}`

              trackTealEvent({
                tealium_event: "video_event",
                video_type: `${`${heading}-${i + 1}`}|${action}|${
                  time ? time : timeOnPause
                }`,
              })
            }

            return (
              <div css={[tw`relative h-[32rem]`]} key={`video-blocks-${i}`}>
                <video
                  id={`${heading}-${i}`}
                  controls={active}
                  title={heading}
                  src={`${process.env.GATSBY_ASSET_URL}${video_s3?.asset?.s3?.key}`}
                  onClick={() => {
                    setActive(true),
                      mobileView && !active ? videoDiv?.play() : null
                  }}
                  onPlay={() => {
                    //only fire on initial play
                    videoDiv?.currentTime == 0 && tealVideoEvent("start", "0:0")
                  }}
                  onPause={() => {
                    //don't fire on end of video
                    videoDiv?.currentTime !== videoDiv?.duration &&
                      tealVideoEvent("pause")
                  }}
                  onEnded={() => {
                    tealVideoEvent(
                      "ended",
                      `100:${Math.round(videoDiv?.duration)}`,
                    )
                  }}
                  poster={videoBlock[i]?.posterImage?.asset?.url}
                  css={[
                    !active
                      ? tw` object-cover w-full h-full`
                      : tw`object-contain mx-auto w-auto h-[32rem]`,
                  ]}
                ></video>
                <div
                  css={[
                    !active
                      ? tw`block absolute top-1/2 left-1/2 z-50 text-red-400 translate-x-[-50%] translate-y-[-50%] mx-auto pointer-events-none`
                      : tw`hidden`,
                  ]}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    className="bi bi-play"
                    css={[tw`bg-white rounded-full p-0.5`]}
                    viewBox="0 0 16 16"
                    width={"4em"}
                    height={"4em"}
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                  </svg>
                </div>
              </div>
            )
          })}
        </ContentSlider>
      </section>
    </>
  )
}

export default VideoBlocks
